import { createCRUDHook } from './createCRUDHook';
import { ComponentMasterDto } from 'utils/models';
import { COMPONENT_MASTER } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<ComponentMasterDto>(
  {
    entityName: 'ComponentMaster',
    endpoint: COMPONENT_MASTER,
  }
);

export const ComponentMasterContext = Context;
export const useComponentMasterManager = useManager;
export const useComponentMaster = useConsumer;
